<template>
	<ClientOnly>
		<BaseCmsShare :networks="['facebook', 'whatsapp', 'viber', 'email']" v-slot="{items, onShare}">
			<div class="share" v-if="items.length">
				<div v-for="network in items" :key="network" :class="['share-item', 'ss-' + network.code]" @click="onShare(network)">
					<span v-if="network.code == 'email'"><BaseCmsLabel :code="'share_'+network.code" /></span>
					<span v-else>{{network.title}}</span>
				</div>
				<div class="share-label">
					<BaseCmsLabel code="share" />
				</div>
			</div>
		</BaseCmsShare>
		<CmsShareEmailModal />
	</ClientOnly>
</template>

<style lang="less">
	.share{
		display: flex; flex-direction: column; position: absolute; top: 5px; left: 0; z-index: 111;
		&.fixed{position: fixed; top: 150px;}
		&.fixed-bottom{position: absolute; top: unset; bottom: 0;}

		@media (max-width: @t){flex-direction: row; position: relative; top: unset; left: unset; right: unset; bottom: unset; margin-top: 30px; padding-top: 28px;}
		@media (max-width: @m){padding-top: 22px; margin-top: 15px;}
	}
	.share-item{
		width: 54px; height: 54px; border: 1px solid @borderColor; background: @white; color: @white; margin-bottom: -1px; cursor: pointer; font-size: 0; line-height: 0; display: flex; align-items: center; justify-content: center; position: relative; .transition(padding);
		&:before{.pseudo(auto,auto); left: -1px; top: -1px; right: -1px; bottom: -1px; background: linear-gradient(270deg, #0078B4 0%, #0050A0 100%); opacity: 0; z-index: -1;}
		&:after{.icon-facebook(); font: 15px/54px @fonti; color: @blue; z-index: 11; width: 54px; display: flex; align-items: center; justify-content: center; position: absolute; left: 0; top: 0; bottom: 0;}
		span{margin-left: 30px;}
		@media (min-width: @t){
			&:hover{
				font-size: 12px; line-height: 1.5; padding: 0 20px 0 20px; font-weight: 600; width: auto; z-index: 1;
				&:before{opacity: 1;}
				&:after{color: @white; font-weight: normal;}
			}
		}

		@media (max-width: @l){
			width: 50px; height: 54px;
			&:after{width: 50px;}
		}
		@media (max-width: @t){
			width: 44px; height: 44px; margin: 0 -1px 0 0;
			&:after{font-size: 14px; line-height: 44px; width: 44px;}
			span{margin-left: 0;}
		}
	}
	.share-icon{
		&:after{
			.icon-facebook(); font: 15px/54px @fonti; color: @blue; z-index: 11;

			@media (max-width: @t){font-size: 14px;}
		}
	}
	.ss-whatsapp:after{
		.icon-wp(); font-size: 18px;

		@media (max-width: @t){font-size: 16px;}
	}
	.ss-viber:after{
		.icon-viber(); font-size: 18px;

		@media (max-width: @t){font-size: 16px;}
	}
	.ss-email:after{
		.icon-close-envelope(); font-size: 13px;

		@media (max-width: @t){font-size: 12px;}
	}

	.share-label{
		font: 13px/14px @font; color: #242F41; text-transform: uppercase; position: absolute; bottom: -40px; left: 14px; .rotate(-90deg);

		@media (max-width: @l){left: 12px;}
		@media (max-width: @t){font-size: 12px; line-height: 18px; position: absolute; bottom: unset; left: 0; top: 0; transform: none;}
		@media (max-width: @ms){font-size: 12px; line-height: 14px;}
	}
</style>
